function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCalendarVacancyFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 5h-3V3h-2v2H10V3H8v2H5a2 2 0 00-2 2v7h26V7a2 2 0 00-2-2zm0 7H5V7h3v3h2V7h12v3h2V7h3v5z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 27H5V16H3v11a2 2 0 002 2h22a2 2 0 002-2V16h-2v11z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.365 15.87l1.404 1.075-5.759 7.404-3.777-2.922 1.075-1.404 2.389 1.85 4.668-6.004z",
    fill: props.color
  }));
}

export default SvgIconCalendarVacancyFilled;